import { DefaultConfigProps } from 'types/config';

type Environment = 'dev' | 'prod';
let ENVIRONMENT = (process.env.REACT_APP_ENVIRONMENT as Environment) || 'dev';
// --- For testing production config in local dev --- //
// ENVIRONMENT = "prod"

// Shared theme config
const baseThemeConfig: DefaultConfigProps = {
  defaultPath: '/home-page',
  fontFamily: `'Inter', sans-serif`,
  i18n: 'en',
  miniDrawer: false,
  container: false,
  mode: 'light',
  presetColor: 'theme3', //'theme3',
  themeDirection: 'ltr'
};

// Configs by environment
const CONFIGS = {
  dev: {
    ENVIRONMENT: 'dev' as const,
    FT_ORG_ID: '6Cj5eVirJIvVhxQZQTfy',
    APP_URL: 'https://dev.forsler.com',
    ERROR_LOG_ENABLED: false,
    DEFAULT_FILES_BUCKET: 'gs://todaysforest-dev_app_files',
    SEGES_ORG_NAME: 'RPE Holding ApS',
    SEGES_ORG_ID: '6Cj5eVirJIvVhxQZQTfy',
    FIREBASE_API: require('./firebase-dev.json'),
    CLOUD_FUNCTIONS_URL: 'https://europe-west3-todaysforest-dev.cloudfunctions.net/',
    INTERNAL_API_BASE_URL: 'https://foresting-tomorrow-internal-d5yy7f55nq-ey.a.run.app',
    PF_WORKSPACE_CODE: 'P88FHpgM1g0XBdee',
    CRISP_KEY: '485edb08-b17e-4fa6-82b3-8287d623a09f',
    MP_TOKEN: '5a6f489b30b3213e27c7afbaf1eb8301',
    MP_DEBUG: false,
    REEPAY_365_DAY_TRIAL_PLAN_ID: '365-dages-pr-veperiode-dev'
  },
  prod: {
    ENVIRONMENT: 'prod' as const,
    FT_ORG_ID: 'MaIA81uR7vgbxhbywk4p',
    APP_URL: 'https://app.forsler.com',
    ERROR_LOG_ENABLED: true,
    DEFAULT_FILES_BUCKET: 'gs://forsler-prod_app_files',
    SEGES_ORG_NAME: 'SEGES Innovation P/S',
    SEGES_ORG_ID: 'AWb2ZBIzwDgsn7tvX6ok',
    FIREBASE_API: require('./firebase-prod.json'),
    CLOUD_FUNCTIONS_URL: 'https://europe-west3-forsler-prod.cloudfunctions.net/',
    INTERNAL_API_BASE_URL: 'https://foresting-tomorrow-internal-4yr7fia4nq-ey.a.run.app',
    PF_WORKSPACE_CODE: 'EcwDOIyEtb9ljkdl',
    CRISP_KEY: '485edb08-b17e-4fa6-82b3-8287d623a09f',
    MP_TOKEN: '88a7f4ed6ed515b442d02e577475e7da',
    MP_DEBUG: false,
    REEPAY_365_DAY_TRIAL_PLAN_ID: '365-dages-pr-veperiode'
  }
};

const envConfig = CONFIGS[ENVIRONMENT];
const appConfig = { ...envConfig, config: baseThemeConfig };
export { ENVIRONMENT, appConfig };
export default appConfig;
